import React from "react";

interface ModalProps {
  isOpen: boolean;
  modalAnimation: string;
  onClose: () => void;
  // Allow null for the ref.
  modalRef: React.RefObject<HTMLDivElement | null>;
  children: React.ReactNode;
  headerText:string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, modalAnimation, onClose, modalRef, children,headerText }) => {
  if (!isOpen) return null;

  return (
    <div className={`feedback-modal ${modalAnimation}`} ref={modalRef} role="dialog" aria-modal="true">
      <div className="feedback-header">
        <h3 id="feedback-header">{headerText}</h3>
        <button className="close-button" onClick={onClose} aria-label="Close feedback form">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18 6L6 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
      <div className="feedback-content">{children}</div>
    </div>
  );
};

export default Modal;
